import { env } from "@/env.cjs";

export function downloadFile(fileUrl: string) {
	const fileDownloadURL = env.NEXT_PUBLIC_FILE_DOWNLOAD_BASE_URL;
	const link = document.createElement("a");
	link.href = fileDownloadURL + fileUrl;
	link.download;
	link.click();
}
